<template>
        <!-- Masthead-->
        <header class="masthead bg-primary text-white text-center">
            <router-link to="/"><div class="container d-flex align-items-center flex-column" style="background-size:cover; background-position:center; height:100%; background-image:'url'('../assets/heyphil-video.mp4')">
                 <video autoplay muted loop class="backdrop">
            <source src="../assets/heyphil-video.mp4" type="video/mp4" />
              </video>
            </div></router-link>
        </header>
</template>

<script>

export default {
   name: 'PhilVideo'
}
</script>

<style scoped>
.backdrop {
  position: fixed;
  z-index: 10000;
  left: 0;
  width: 100vw;
  height: 100vh;
  top: 0;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
